export var SELECT="SELECT";export var TOGGLE="TOGGLE";export var SET_ALL="SET_ALL";export var CLEAR_ALL="CLEAR_ALL";